import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import Blog from "./pages/Blog/Blog";
import BlogDetails from "./pages/Blog/BlogDetails";

import Contact from "./pages/Contact/Contact";
import Terms from "./pages/Terms-Conditions/terms-and-conditions";
import Privacy from "./pages/Privacy/privacy-policy";
import RefundPolicy from "./pages/Refund-Policy/refund-Policy";
import ShippingPolicy from "./pages/Shipping-Policy/Shipping-Policy";
import LoginOfferPopup from "./components/LoginOfferPopup/LoginOfferPopup";
import Disclaimer from "./pages/Disclaimer/Disclaimer";
import ConsultationPolicy from "./pages/ConsultationPolicy/ConsultationPolicy";
import Faq from "./pages/Faq/Faq";
import About from "./pages/About/About";
import AdminLogin from "./pages/Admin/AdminLogin";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import ProductDetails from "./pages/ProductDetails";
import ProductOnDemand from "./pages/ProductOnDemand/ProductOnDemand";
import CategoryProducts from "./pages/CategoryProducts/CategoryProducts";
import VaidikVidhya from "./pages/VaidikVidhya/VaidikVidhya";
import ConsultationHome from "./pages/Consultation/ConsultationHome";
import ConsultationService from "./pages/Consultation/ConsultationService";
import ConsultationBooking from "./pages/Consultation/ConsultationBooking";
import ConsultationConfirmation from "./pages/Consultation/ConsultationConfirmation";
import ShopCategoryPage from "./pages/ShopCategoryPage/ShopCategoryPage";
import RecordedCourse from "./pages/VaidikVidhya/RecordedCourse";
import Youraccount from "./pages/Youraccount";
import Login from "./pages/Login";
import Checkout from "./pages/Checkout/Checkout";
import OrderConfirmation from "./pages/OrderConfirmation/OrderConfirmation";
import ConfirmOrder from "./pages/ConfirmOrder/ConfirmOrder";
import SearchResults from "./pages/Search/SearchResults";
import MobileNumerology from "./pages/MobileNumerology/MobileNumerology";
import MobileNumerologyPolicy from "./pages/MobileNumerology/MobileNumerologyPolicy";
import RudrakshaCalculator from "./pages/RudrakshaCalculator/RudrakshaCalculator";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";

// import AdminLogin from "./pages/Admin/AdminLogin";
function App() {
  return (
    // <BrowserRouter>
    //   <Routes>
    //     <Route path="/" element={<Home />} />
    //     <Route path="/about" element={<About />} />
    //     <Route path="/blog" element={<Blog />} />
    //     <Route path="/contact" element={<Contact />} />
    //     <Route path="/terms" element={<Terms />} />
    //     <Route path="/Privacy" element={<Privacy />} />
    //     <Route path="/refund" element={<Refund />} />
    //     <Route path="/Shipping-Returns" element={<ShippingReturns />} />
    //     <Route path="/faq" element={<Faq />} />
    //     <Route path="/product/:id" element={<ProductDetails />} />
    //     <Route path="/category/:category" element={<CategoryProducts />} />
    //     <Route
    //       path="/shop/:mainCategory"
    //       element={<ShopCategoryPage />}
    //     />
    //     {/* Sub Category */}
    //     <Route
    //       path="/shop/:mainCategory/:subCategory"
    //       element={<CategoryProducts />}
    //     />
    //     <Route path="/rashi/:rashi" element={<CategoryProducts />} />
    //     {/* Admin Routes */}
    //     <Route path="/admin/login" element={<AdminLogin />} />
    //     <Route path="/admin/dashboard" element={<AdminDashboard />} />
    //   </Routes>
    // </BrowserRouter>
     <CartProvider>
    <BrowserRouter>
      <AuthProvider>
        <LoginOfferPopup />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogDetails />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms-and-conditions" element={<Terms />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/refund-Policy" element={<RefundPolicy />} />
          <Route path="/Shipping-Policy" element={<ShippingPolicy />} />
          <Route path="/website-disclaimer" element={<Disclaimer />} />
          <Route path="/consultation-policy" element={<ConsultationPolicy />} />
          <Route path="/faq" element={<Faq />} />
          Change of picture of customers in existing reviews in Consultation
          Section.
          {/* <Route path="/product/:id" element={<ProductDetails />} /> */}
          <Route path="/product/:id" element={<ProductDetails />} />
          <Route path="/product-on-demand" element={<ProductOnDemand />} />
          <Route path="/shop/product-on-demand" element={<ProductOnDemand />} />
          <Route path="/shop/:mainCategory" element={<ShopCategoryPage />} />
          <Route
            path="/shop/:mainCategory/:subCategory"
            element={<CategoryProducts />}
          />
          <Route path="/rashi/:rashi" element={<CategoryProducts />} />
          <Route path="/search" element={<SearchResults />} />
          <Route path="/rudraksha-calculator" element={<RudrakshaCalculator />} />
          <Route path="/mobile-numerology" element={<MobileNumerology />} />
          <Route
            path="/mobile-numerology-policy"
            element={<MobileNumerologyPolicy />}
          />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/vaidik-vidhya" element={<VaidikVidhya />} />
          <Route path="/consultation" element={<ConsultationHome />} />
          <Route
            path="/consultation/confirmation"
            element={<ConsultationConfirmation />}
          />
          <Route
            path="/consultation/book/:slug"
            element={<ConsultationBooking />}
          />
          <Route
            path="/consultation/:category"
            element={<ConsultationHome />}
          />
          <Route
            path="/consultation/:category/:slug"
            element={<ConsultationService />}
          />
          <Route path="/course/:slug/recorded" element={<RecordedCourse />} />
          <Route path="/adminDashboard" element={<AdminDashboard />} />
          <Route path="/adminLogin" element={<AdminLogin />} />
          <Route path="/account" element={<Youraccount />} />
          <Route path="/login" element={<Login />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/order-confirmation" element={<OrderConfirmation />} />
          <Route path="/confirm-order/:token" element={<ConfirmOrder />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
    </CartProvider>
  );
}

export default App;
